//This is the recipes page it will link to other recipes

import RecipesComponent from "../../NonMVPComponents/Recipes/RecipesComponent";

const Recipes = () => {
  return (
    <div>
      <RecipesComponent />
    </div>
  );
};

export default Recipes;
